
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/monday",
      function () {
        return require("private-next-pages/destinations/monday.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/monday"])
      });
    }
  